import type { ReactNode } from 'react';

/** Inline status banner. role=alert so screen readers announce it immediately. */
export function Alert({
  kind,
  children,
}: {
  kind: 'error' | 'success' | 'info';
  children?: ReactNode;
}) {
  if (!children) return null;
  return (
    <div className={`alert alert-${kind}`} role="alert">
      {children}
    </div>
  );
}
